export const corporateBtnsList = [
  {name: 'Предрейсовые осмотры', type: 'corporate-btns', link: 'https://b2b.eclinic.center/page42797464.html'},
  {name: 'Здравпункты на предприятиях', type: 'corporate-btns', link: 'https://b2b.eclinic.center/page42797466.html'},
  {name: 'Выездная вакцинация', type: 'corporate-btns', link: 'https://b2b.eclinic.center/page42797470.html'},
  {name: 'Здоровье топ-менеджеров', type: 'corporate-btns', link: 'https://b2b.eclinic.center/page45160839.html'},
  {name: 'Корпоративным клиентам', type: 'corporate-btns', link: 'https://b2b.eclinic.center/'},
]